import styled from 'styled-components';

const HeaderStyle = styled.header`
	--headerPadTB: var(--sp5x);
	--logoWidth: var(--sp32x);
	--logoHeight: var(--sp5x);
	--rightBlockItemDistance: var(--sp2x);
	--rightBlockItemIconSize: var(--sp5x);
	--cartGap: var(--sp1x);

	--shopOnlineSvgSize: var(--sp3-5x);
	--shopOnlineBlockDistance: var(--sp11x);
	--shopOnlineContentGap: var(--sp1-5x);

	--deltaRightBLockDistance: var(--sp15x);

	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	width: 100%;
	height: calc(var(--headerFixedHeight) + var(--headerBannerHeight));
	padding-top: var(--headerBannerHeight);
	background-color: var(--neutral1000);
	z-index: 1000;

	.header-container {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: var(--headerPadTB) var(--contPaddingLR);
	}

	&.has-desktop-center-fulfillment {
		.header-container {
			position: relative;
		}

		.header-center-fulfillment {
			position: absolute;
			left: 50%;
			top: 50%;
			z-index: 2;
			width: 100%;
			max-width: min(
				calc(
					2 *
						min(
							50vw - var(--contPaddingLR, 0px) - var(--logoWidth, 520px) - var(
									--deltaRightBLockDistance,
									0px
								),
							50vw - var(--contPaddingLR, 0px) - var(--header-right-block-width, 0px) - var(
									--deltaRightBLockDistance,
									0px
								)
						)
				)
			);
			transform: translate(-50%, -50%);
			opacity: 1;
			pointer-events: auto;
		}
	}

	&.is-home-desktop-header:not(.has-home-desktop-sticky-delivery) {
		.header-center-fulfillment {
			transform: translate(-50%, calc(-50% - 140%));
			opacity: 0;
			pointer-events: none;
			transition:
				transform var(--trTime) ease-out,
				opacity var(--trTime) ease-out;
			will-change: transform, opacity;
		}
	}

	&.is-home-desktop-header.has-home-desktop-sticky-delivery {
		.header-center-fulfillment {
			transform: translate(-50%, -50%);
			opacity: 1;
			pointer-events: auto;
			transition:
				transform var(--trTime) ease-out,
				opacity var(--trTime) ease-out;
		}
	}

	@media (prefers-reduced-motion: reduce) {
		&.is-home-desktop-header .header-center-fulfillment {
			transition: none;
		}
	}

	.logo-block {
		--proportion: 0;

		width: var(--logoWidth);
		flex-shrink: 0;
		background-color: transparent !important;

		img {
			position: relative !important;
			object-fit: contain !important;
		}
	}

	.right-block {
		display: flex;
		align-items: center;
		gap: var(--rightBlockItemDistance);
		min-width: 0;
	}

	&.has-mobile-collapsible-header {
		display: flex;
		flex-direction: column;
		padding-top: 0;
		height: auto;
		overflow-x: clip;
		overflow-y: visible;

		.header-top-scroll {
			display: flex;
			flex-direction: column;
			flex-shrink: 0;
			overflow-x: clip;
			overflow-y: visible;
			height: 0px;
		}

		.header-banner-slot {
			position: relative;
			flex-shrink: 0;
			width: 100%;
			overflow: hidden;
			z-index: 2;
			min-height: var(--headerBannerHeight);
			height: var(--header-banner-slot-height, var(--headerBannerHeight));

			.wrapper-contact {
				position: relative !important;
				top: auto !important;
				left: auto !important;
				width: 100%;
				overflow: hidden;
			}
		}

		.header-collapse-layer {
			position: relative;
			z-index: 1;
			flex-shrink: 0;
			transform: translate3d(0, 0, 0);
			-webkit-transform: translate3d(0, 0, 0);
			-webkit-backface-visibility: hidden;
			backface-visibility: hidden;
			/* Always on GPU — no layer creation/destruction cost during animation */
			will-change: transform;
			transition: transform var(--trTime) ease-out;
		}

		&.is-nav-hidden .header-collapse-layer {
			transform: translate3d(0, calc(-1 * var(--nav-height, var(--headerFixedHeight))), 0);
			-webkit-transform: translate3d(0, calc(-1 * var(--nav-height, var(--headerFixedHeight))), 0);
		}

		@media (prefers-reduced-motion: reduce) {
			.header-collapse-layer {
				transition: none;
			}
		}

		.header-nav-slot {
			flex-shrink: 0;
			height: var(--nav-height, 80px);
			overflow: hidden;
			background-color: var(--neutral1000);
		}

		&:not(.is-nav-hidden) .header-nav-slot {
			overflow: visible;
		}

		.header-nav-slot-inner {
			height: 100%;
		}

		.header-container {
			position: relative;
			background-color: var(--neutral1000);
		}
	}

	&.has-mobile-collapsible-header.is-nav-hidden {
		.header-nav-slot {
			pointer-events: none;
		}
	}

	&.has-shop-fulfillment-bar {
		.header-banner-slot {
			z-index: 3;
		}

		.shop-fulfillment-slot {
			flex-shrink: 0;
			z-index: 3;
			background-color: var(--neutral1000);
			overflow: visible;
			min-height: 52px;
		}
	}

	.shop-online-link-block {
		margin-right: calc(var(--shopOnlineBlockDistance) - var(--rightBlockItemDistance));
	}

	.shop-online-block {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: var(--shopOnlineContentGap);
		white-space: nowrap;

		svg {
			max-width: var(--shopOnlineSvgSize);
		}
	}

	.cart-block {
		display: grid;
		grid-template-columns: 1fr 1.3fr;
		align-items: center;
		gap: var(--cartGap);

		.ext-block {
			display: flex;
			align-items: center;
			justify-content: space-between;
		}
	}

	.login-icon,
	.shop-icon {
		font-size: var(--rightBlockItemIconSize);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--logoHeight: var(--sp4-5x);
		--rightBlockItemIconSize: var(--sp4x);
		--cartGap: var(--sp0-5x);
		--paddingBannerTB: var(--sp1x);
		--shopOnlineBlockDistance: var(--sp10x);

		--deltaRightBLockDistance: var(--sp10x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--rightBlockItemDistance: var(--sp1-5x);
		--headerPadTB: var(--sp4x);
		--shopOnlineSvgSize: var(--sp2-5x);
		--shopOnlineBlockDistance: var(--sp9x);
		--shopOnlineContentGap: 10px;
		--deltaRightBLockDistance: var(--sp5x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--headerPadTB: var(--sp3x);
		--logoWidth: var(--sp27x);
		--logoHeight: var(--sp4x);
		--rightBlockItemIconSize: var(--sp3-5x);
		--shopOnlineSvgSize: var(--sp2x);
		--shopOnlineBlockDistance: var(--sp8x);
		--shopOnlineContentGap: var(--sp1x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--rightBlockItemIconSize: var(--sp3x);
		--shopOnlineBlockDistance: var(--sp7x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--headerPadTB: var(--sp2x);
		--logoWidth: var(--sp25x);
		--logoHeight: var(--sp3-5x);
		--paddingBannerLR: var(--sp2x);
		--shopOnlineBlockDistance: var(--sp4x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--logoWidth: var(--sp3x);
		--logoHeight: var(--sp5x);
		--paddingBannerLR: var(--sp2x);
		--shopOnlineBlockDistance: var(--sp2x);
	}
`;

export default HeaderStyle;
